import { toast } from "react-toastify"
import ThemeMaker from "../../components/thememaker"
import { useState, useEffect } from "react"
import axios from "axios"
import { config } from "../../utils/config"
import { tokenDecode } from "../../utils/helper"
import brandStyles from "../Brand/Brand.module.css"
import "../../components/table.css"
import "../../components/mcrbTableTheme.css"

const rawForm = {
  org_person_name: "",
  org_email: "",
  org_phone: "",
  gro_person_name: "",
  gro_email: "",
  gro_phone: "",
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const PHONE_REGEX = /^[6-9]\d{9}$/

export default function Grievance() {
  const { baseNodeapiUrl } = config
  const decoded: any = tokenDecode()
  const seller_id = decoded?.data?.user?.seller_id
  const provider_id = decoded?.data?.seller_data?.provider_id
  const isAdmin = Number(seller_id) === 1

  const [formData, setformData] = useState({ ...rawForm })
  const [isSaving, setIsSaving] = useState(false)
  const [supportList, setSupportList] = useState<any[]>([])
  const [listLoading, setListLoading] = useState(false)

  useEffect(() => {
    getOrganizationDetails()
    if (isAdmin) getAllSellerSupport()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function getAllSellerSupport() {
    try {
      setListLoading(true)
      const { data } = await axios({
        url: `${baseNodeapiUrl}/igm/getallSellersupport`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      })
      setSupportList(Array.isArray(data?.data) ? data.data : [])
    } catch (err) {
      console.log("Error in Server----", err)
      toast.error("Unable to load Seller Support list")
    } finally {
      setListLoading(false)
    }
  }

  async function getOrganizationDetails() {
    try {
      
      const { data } = await axios({
        url: `${baseNodeapiUrl}/igm/getorgsupport`,
        method: "POST",
        data: { seller_id, provider_id },
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      })

      const d = (Array.isArray(data?.data) ? data.data[0] : data?.data)
        ?? data?.details ?? data?.igmDetails ?? {}
      setformData({
        org_person_name: d?.org_person_name ?? "",
        org_email: d?.org_email ?? "",
        org_phone: d?.org_phone ?? "",
        gro_person_name: d?.gro_person_name ?? "",
        gro_email: d?.gro_email ?? "",
        gro_phone: d?.gro_phone ?? "",
      })
    } catch (err) {
      console.log("Error in Server----", err)
      toast.error("Server not working, Please try again later")
    }
  }

  function onChangeHandler(e: any) {
    setformData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  function onPhoneChangeHandler(e: any) {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10)
    setformData((prev) => ({ ...prev, [e.target.name]: digitsOnly }))
  }

  async function submitHandler() {
    const { org_person_name, org_email, org_phone, gro_person_name, gro_email, gro_phone } = formData
    if (
      !org_person_name || !org_email || !org_phone ||
      !gro_person_name || !gro_email || !gro_phone
    ) {
      toast.error("Please fill all Organisation and GRO details")
      return
    }

    if (!EMAIL_REGEX.test(org_email)) {
      toast.error("Please enter a valid Organisation Email")
      return
    }
    if (!EMAIL_REGEX.test(gro_email)) {
      toast.error("Please enter a valid GRO Email")
      return
    }
    if (!PHONE_REGEX.test(org_phone)) {
      toast.error("Please enter a valid 10-digit Organisation Contact Number")
      return
    }
    if (!PHONE_REGEX.test(gro_phone)) {
      toast.error("Please enter a valid 10-digit GRO Contact Number")
      return
    }

    try {
      setIsSaving(true)
      await axios({
        url: `${baseNodeapiUrl}/igm/org_support`,
        method: "POST",
        data: {
          seller_id,
          provider_id,
          org_phone,
          org_person_name,
          org_email,
          gro_phone,
          gro_person_name,
          gro_email,
        },
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      })

      toast.success("Data Saved Successfully!")
      getOrganizationDetails()
    } catch (err) {
      toast.error("Something Went Wrong! Please try again later.")
    } finally {
      setIsSaving(false)
    }
  }

  const preventMinus = (e: any) => {
    if (e.code === "Minus") {
      e.preventDefault()
    }
  }

  return (
    <ThemeMaker>
      <div className={`${brandStyles.pageWrap} mcrb-page`}>
        <div className={`${brandStyles.cardOuter} mcrb-card`}>
          <div className={brandStyles.headerBar}>
            <span className={brandStyles.title}>Grievance Settings</span>
          </div>

          <div className={brandStyles.bodyArea}>
            <p style={{ fontFamily: "'Sora', 'Inter', sans-serif", fontSize: "14px", fontWeight: 700, color: "#4c2fb3", margin: "0 0 14px" }}>Organisation Details</p>
            <div className="row">
              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>Organisation Name<span className={brandStyles.required}>*</span></label>
                  <input type="text" name="org_person_name" className={brandStyles.input} placeholder="Enter Name" value={formData.org_person_name} onChange={onChangeHandler} />
                </div>
              </div>
              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>Organisation Email<span className={brandStyles.required}>*</span></label>
                  <input type="email" name="org_email" className={brandStyles.input} placeholder="Enter Email" value={formData.org_email} onChange={onChangeHandler} />
                </div>
              </div>
              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>Organisation Contact Number<span className={brandStyles.required}>*</span></label>
                  <input type="tel" inputMode="numeric" maxLength={10} name="org_phone" className={brandStyles.input} placeholder="Enter Contact" value={formData.org_phone} onKeyPress={preventMinus} onChange={onPhoneChangeHandler} />
                </div>
              </div>
            </div>

            <p style={{ fontFamily: "'Sora', 'Inter', sans-serif", fontSize: "14px", fontWeight: 700, color: "#4c2fb3", margin: "22px 0 14px" }}>Grievance Redressal Officer (GRO)</p>
            <div className="row">
              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>GRO Name<span className={brandStyles.required}>*</span></label>
                  <input type="text" name="gro_person_name" className={brandStyles.input} placeholder="Enter Name" value={formData.gro_person_name} onChange={onChangeHandler} />
                </div>
              </div>
              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>GRO Email<span className={brandStyles.required}>*</span></label>
                  <input type="email" name="gro_email" className={brandStyles.input} placeholder="Enter Email" value={formData.gro_email} onChange={onChangeHandler} />
                </div>
              </div>
              <div className="col-md-6">
                <div className={brandStyles.field}>
                  <label className={brandStyles.label}>GRO Contact Number<span className={brandStyles.required}>*</span></label>
                  <input type="tel" inputMode="numeric" maxLength={10} name="gro_phone" className={brandStyles.input} placeholder="Enter Contact" value={formData.gro_phone} onKeyPress={preventMinus} onChange={onPhoneChangeHandler} />
                </div>
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center", marginTop: "28px" }}>
              <button type="button" className={brandStyles.saveBtn} style={{ width: "220px" }} disabled={isSaving} onClick={submitHandler}>
                {isSaving ? "Saving..." : "Submit"}
              </button>
            </div>
          </div>
        </div>

        {isAdmin && (
        <>
        <div style={{ height: "24px" }} />

        <div className={`${brandStyles.cardOuter} mcrb-card`}>
          <div className={brandStyles.headerBar}>
            <span className={brandStyles.title}>Seller Support List</span>
            <span style={{ fontSize: "12px", fontWeight: 700 }}>
              {supportList.length} record{supportList.length === 1 ? "" : "s"}
            </span>
          </div>

          <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap}`}>
            {listLoading ? (
              <p className="text-center py-4" style={{ color: "#6B7280" }}>Loading...</p>
            ) : supportList.length === 0 ? (
              <p className="text-center py-4" style={{ color: "#6B7280" }}>No seller support records found.</p>
            ) : (
              <table className="custom-table" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Provider ID</th>
                    <th>Support Person</th>
                    <th>Support Phone</th>
                    <th>Support Email</th>
                    <th>GRO Person</th>
                    <th>GRO Phone</th>
                    <th>GRO Email</th>
                    <th>Updated</th>
                  </tr>
                </thead>
                <tbody>
                  {supportList.map((item: any, index: number) => (
                    <tr key={item?.id ?? index}>
                      <td>{index + 1}</td>
                      <td>{item?.provider_id || "-"}</td>
                      <td>{item?.support_person_name || "-"}</td>
                      <td>{item?.support_phone || "-"}</td>
                      <td>{item?.support_email || "-"}</td>
                      <td>{item?.gro_person_name || "-"}</td>
                      <td>{item?.gro_phone || "-"}</td>
                      <td>{item?.gro_email || "-"}</td>

                      <td>{item?.updated_at ? new Date(item.updated_at).toLocaleDateString() : "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
        </>
        )}
      </div>
    </ThemeMaker>
  )
}
